module.exports = __webpack_public_path__ + "static/media/cq_nuovo_documento.c4d09a3d.svg";